import { Button } from '@mui/material';
import React from 'react';

const NFG_SETUP_URL =
  'https://joindeed.notion.site/Deed-x-Network-for-Good-999daec30e3d476094b50046a2549b26?pvs=4';

export const RegisterWithNfgBlock = ({ children }: { children?: React.ReactNode }) => (
  <>
    <p>Register with NFG and enroll your organization (it only takes a few minutes)</p>
    {children}
    <div style={{ marginTop: 15 }}>
      <Button color="primary" variant="contained" href={NFG_SETUP_URL}>
        Register with NFG
      </Button>
    </div>
  </>
);
